import actions from './actions'

export default function CountrysReducer(state = { loading: false }, action) {
  switch (action.type) {
    case actions.REQUESTING:
      return {
        ...state,
        loading: true,
        editing: null,
        saveSuccess: false,
      }
    case actions.LIST_COUNTRY2:
      return {
        ...state,
        result: action.result,
        loading: false,
        saveSuccess: false,
      }
    case actions.EDIT_COUNTRY2:
      return {
        ...state,
        editing: action.result,
        loading: false,
        saveSuccess: false,
      }
    case actions.RESET_COUNTRY2:
      return {
        ...state,
        editing: null,
        loading: false,
        saveSuccess: false,
      }
    case actions.NEW_COUNTRY2:
      return {
        ...state,
        editing: { ID: 0 },
        loading: false,
        saveSuccess: false,
      }
    case actions.CREATE_COUNTRY2_RECIEVED ||
      actions.UPDATE_COUNTRY2_RECIEVED ||
      actions.DELETE_COUNTRY2_RECIEVED:
      return {
        ...state,
        editing: { ID: 0 },
        loading: false,
        saveSuccess: true, // mark
      }
    case actions.RESPONSE_ERROR:
      return {
        ...state,
        loading: false,
        error: true,
        saveSuccess: false,
        message: action.message,
      }
    default:
      return state
  }
}
